
import { observer } from "mobx-react";

import {
  Client,
  Clients,
  AppState,
  getClients,
  getCollectionByName,
  getAppState,
} from '../models';

import {
  BaseDetailPage,
} from './BaseDetailPage';
import {
  BaseTabbedDetailPage,
} from './BaseTabbedDetailPage';


interface ClientDetailProps {
  history?: any;
  match?: any;
  location?: any;
  client?: Client;
}

type ComponentState = any;



@observer
class ClientDetail extends BaseDetailPage<ClientDetailProps, ComponentState> {

  viewName = 'Client Detail';
  objectName = 'client';

  

  


  

  
  get defaultViewMode() {
    return 'edit';
  }
  

  newObject() {
    return new Client();
  }

  getCollection(): Clients {
    return getClients();
  }

  getAppState(): AppState {
    return getAppState();
  }

  getRelatedModelCollections() {
    let appState = this.getAppState();
    return [
      
      
        {
          name: 'Contacts - Client',
          related_field: 'attached_to_client',
          for_model: 'Contact',
          
          collection: getCollectionByName('contact')
        },
      
      
      
        {
          name: 'Tasks - Client',
          related_field: 'attached_to_client',
          for_model: 'Task',
          
          collection: getCollectionByName('task')
        },
      
      
        {
          name: 'Notes - Clients',
          related_field: 'clients',
          for_model: 'Note',
          
          collection: getCollectionByName('note')
        },
      
      
        {
          name: 'Files - Client',
          related_field: 'attached_to_client',
          for_model: 'File',
          
          collection: getCollectionByName('file')
        },
      
      
      
      
    ];
  }

}

export default ClientDetail;